import { render, staticRenderFns } from "./ConfigureStatus.vue?vue&type=template&id=2c690256&scoped=true"
import script from "./ConfigureStatus.vue?vue&type=script&lang=js"
export * from "./ConfigureStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c690256",
  null
  
)

export default component.exports